export const COOKIES_KEYS = {
  "pure.journal.smart_banner.disabled": "pure.journal.smart_banner.disabled",
}
